import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useMutation, useQueryClient } from 'react-query'
import { useDispatch } from 'react-redux'
import { push } from 'react-router-redux'
import withApiData from '../HOC/withApiData'
import colors from '../../configuration/colors'
import { hideModal } from '../../actions/modal'
import Modal from '../mini/Modal'
import Button from '../mini/Buttons/Button'
import styled from 'styled-components'
import H2 from '../typography/headers/H2'
import MarginRight15 from '../typography/margins/MarginRight15'
import CancelButton from '../mini/Buttons/CancelButton'
import ReactTooltip from 'react-tooltip'
import TextInputComponent from './CreateOrEditCourseModal/InputComponents/TextInputComponent'
import { createNewLevelActivity } from '../mycourses/Activities/API'

const ModalContainer = styled.div`
  width: 660px;
  border-radius: 10px;
  box-shadow: 0 2px 3.8px 0.2px rgba(0, 0, 0, 0.15);
  background-color: ${colors.smoke};
  margin: 180px auto;
`

const FlexContainer = styled.div`
  display: flex;
  justify-content: space-between;
`

const HeaderContainer = styled.div`
  height: 80px;
  width: auto;
  border-radius: 10px 10px 0 0;
  background-color: ${colors.white};
  border-bottom: 1px solid ${colors.rock};
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 30px;
`

const MainContainer = styled.div`
  padding: 0 30px 30px;
`

const CreateActivityModal = ({
  apiData,
  activityCourseId,
  journeyId,
  levelId
}) => {
  const dispatch = useDispatch()
  const queryClient = useQueryClient()

  const closeTheModal = () => {
    setTimeout(() => {
      dispatch(hideModal())
    }, 300)
  }

  const [activityName, setActivityName] = useState('')
  const handleActivityName = e => {
    setActivityName(e.target.value)
  }

  const createMutation = useMutation(({ levelId, activityName }) =>
    createNewLevelActivity(apiData, levelId, activityName)
  )
  const couldSaveData = activityName.length > 0

  const handleSaveNewActivity = () => {
    if (couldSaveData) {
      createMutation.mutate(
        {
          apiData,
          levelId,
          activityName
        },
        {
          onSuccess: data => {
            queryClient.invalidateQueries('level-activities-' + levelId)
            setTimeout(() => {
              closeTheModal()
              dispatch(
                push(
                  `/mycourses/${activityCourseId}/journey/${journeyId}/level/${levelId}/activityQuest/${data.id}/edit`
                )
              )
            }, 300)
          }
        }
      )
    }
  }

  return (
    <Modal
      width={1400}
      percentHeight={100}
      background={'rgba(36,54,70,0.48)'}
      lockBodyScroll={false}
      opacity={'.9'}
      allowInnerScroll
      allowCloseOnExternalClick={false}
    >
      <ModalContainer>
        <HeaderContainer>
          <H2>+ New Activity</H2>
          <FlexContainer>
            <MarginRight15>
              <CancelButton
                handleClick={closeTheModal}
                title="Cancel"
                width="104px"
              />
            </MarginRight15>
            <div
              data-for="createCourseTooltip"
              data-tip="Please enter all required fields prior to creating this course."
            >
              <Button
                width="104px"
                title="Create"
                handleClick={handleSaveNewActivity}
                buttonColor={colors.oeYellow}
                borderColor={colors.oeYellow}
                hoverBackground={colors.charcoal4}
                hoverColor={colors.white}
                couldSaveData={couldSaveData}
                shouldShowTooltipAndDisableButton={true}
              />
              {!couldSaveData && (
                <ReactTooltip
                  id="createCourseTooltip"
                  place="bottom"
                  effect="solid"
                  className="activityCourseTooltip"
                />
              )}
            </div>
          </FlexContainer>
        </HeaderContainer>
        <MainContainer>
          <TextInputComponent
            title="Activity Name"
            placeholder="Activity Name"
            handleEnteredTextValue={handleActivityName}
            value={activityName}
            shouldDisplayAsteriskSymbol={true}
          />
        </MainContainer>
      </ModalContainer>
    </Modal>
  )
}

CreateActivityModal.propTypes = {
  apiData: PropTypes.object.isRequired,
  activityCourseId: PropTypes.number.isRequired,
  journeyId: PropTypes.number.isRequired,
  levelId: PropTypes.number.isRequired
}

export default withApiData(CreateActivityModal)



// WEBPACK FOOTER //
// ./src/components/modal/CreateActivityModal.js